import React from 'react';

interface Props {
  activeSection:
    | 'dashboard'
    | 'users'
    | 'prompts'
    | 'categories';

  setActiveSection: (
    section:
      | 'dashboard'
      | 'users'
      | 'prompts'
      | 'categories'
  ) => void;
}

const AdminSidebar: React.FC<Props> = ({
  activeSection,
  setActiveSection,
}) => {
  return (
    <aside className="w-72 bg-[#0B1120] border-r border-white/10 p-6">

      <h1 className="text-2xl font-bold text-white mb-10">
        NEXORA
      </h1>

      <nav className="space-y-3">

        <button
          onClick={() =>
            setActiveSection('dashboard')
          }
          className={`w-full text-left px-4 py-3 rounded-xl transition-all ${
            activeSection === 'dashboard'
              ? 'bg-purple-600 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}
        >
          Dashboard
        </button>

        <button
          onClick={() =>
            setActiveSection('users')
          }
          className={`w-full text-left px-4 py-3 rounded-xl transition-all ${
            activeSection === 'users'
              ? 'bg-purple-600 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}
        >
          Users
        </button>

        <button
          onClick={() =>
            setActiveSection('prompts')
          }
          className={`w-full text-left px-4 py-3 rounded-xl transition-all ${
            activeSection === 'prompts'
              ? 'bg-purple-600 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}
        >
          Prompts
        </button>

        <button
          onClick={() =>
            setActiveSection('categories')
          }
          className={`w-full text-left px-4 py-3 rounded-xl transition-all ${
            activeSection === 'categories'
              ? 'bg-purple-600 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}
        >
          Categorias
        </button>

      </nav>
    </aside>
  );
};

export default AdminSidebar;